module.exports = __webpack_public_path__ + "fonts/iconfont.162960d5.woff2";